export const isCartExpired = (timestamp?: number) => {
  const oneHour = 60 * 60 * 1000;
  const currentTime = Date.now();

  return Boolean(timestamp && currentTime - timestamp > oneHour);
};
